"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = default_1;
const either_1 = require("../../../types/either");
const constants_1 = require("../../designs/constants");
const getMinMaxPagesForBookProject_1 = __importDefault(require("../getMinMaxPagesForBookProject"));
const getBookInteriorPageCount_1 = __importDefault(require("../getBookInteriorPageCount"));
const Printable_1 = require("../../../models/printables/Printable");
const layers_1 = require("../../layers");
const updatePrintableDesign_1 = __importDefault(require("../updatePrintableDesign"));
const UserPhotoLayer_1 = require("../../../models/layers/UserPhotoLayer");
const addInteriorPrintablesToBookProject_1 = __importDefault(require("../addInteriorPrintablesToBookProject"));
const designs_1 = require("../../designs");
const Product_1 = require("../../../models/Product");
const env_1 = require("../../../utils/env");
const newrelic_1 = require("../../split.io/newrelic");
const helpers_1 = require("./helpers");
function default_1(project, action, template, art) {
  var _a, _b, _c, _d, _e;
  const projectId = project.id;
  const timestamp = action.timestamp;
  const logObject = {
    projectId,
    version: project.version,
    flashId: project.createdBy,
    env: (0, env_1.getEnv)(),
    action,
    numOfImagesToFill: (_a = action === null || action === void 0 ? void 0 : action.imagesToFill) === null || _a === void 0 ? void 0 : _a.length
  };
  const updatedEntitiesMap = new Map();
  updatedEntitiesMap.set(projectId, project);
  const images = action.imagesToFill.map(image => Object.assign({
    orientation: (0, helpers_1.calculateImageOrientation)(image.width, image.height)
  }, image));
  const allDesigns = (0, helpers_1.getEnrichedDesigns)(template);
  const autofillableDesigns = allDesigns.filter(design => design.isAutofillable);
  const interiorPrintableGroup = project.printableGroups.find(pg => pg.type === 'interior');
  const interiorPrintableGroupIndex = project.printableGroups.findIndex(pg => pg.type === 'interior');
  if (!interiorPrintableGroup) {
    return (0, either_1.left)(new Error('Project is missing interiorPrintableGroup'));
  }
  const hasPhotos = interiorPrintableGroup.printables.some(printable => (0, Printable_1.hasFilledUserPhotoLayer)(printable));
  if (action.fromScratch && hasPhotos) {
    interiorPrintableGroup.printables.forEach((p, index) => {
      p.layers.forEach(l => {
        if ((0, UserPhotoLayer_1.isUserPhotoLayer)(l) && l.userData) {
          delete l.userData;
        }
      });
      const updatedPrintable = (0, Printable_1.updatePrintableVersion)(p, action.timestamp);
      project.printableGroups[interiorPrintableGroupIndex].printables[index] = updatedPrintable;
      updateMap(updatedEntitiesMap, [updatedPrintable, project]);
    });
  }
  const [, maxPageCount] = (0, getMinMaxPagesForBookProject_1.default)(template, art.category);
  let currentPageCount = (0, getBookInteriorPageCount_1.default)(project.printableGroups, art.category);
  const isSpreadBook = (0, Product_1.isSpreadBooksCategory)(art.category);
  const numPrintablesToAdd = isSpreadBook ? 1 : 2;
  const hasPageCountOption = ((_c = (_b = art === null || art === void 0 ? void 0 : art.attributes) === null || _b === void 0 ? void 0 : _b.standard_page_count) === null || _c === void 0 ? void 0 : _c.options) || ((_e = (_d = art === null || art === void 0 ? void 0 : art.attributes) === null || _d === void 0 ? void 0 : _d.page_count) === null || _e === void 0 ? void 0 : _e.options);
  let emptyPrintable = interiorPrintableGroup.printables.find(printable => (0, Printable_1.hasEmptyUserPhotoLayer)(printable));
  while (images.length > 0 && (emptyPrintable || currentPageCount < maxPageCount)) {
    if (!emptyPrintable) {
      if (hasPageCountOption) {
        break;
      }
      const addPrintablesResult = (0, addInteriorPrintablesToBookProject_1.default)(project, {
        projectId,
        timestamp,
        type: 'ADD_INTERIOR_PRINTABLES_TO_BOOK_PROJECT',
        numPrintablesToAdd
      }, template, art);
      if (addPrintablesResult.isLeft()) {
        sendNewRelicPageAction(Object.assign({
          step: 'addInteriorPrintablesToBookProject',
          error: addPrintablesResult.value
        }, logObject));
        return (0, either_1.left)(addPrintablesResult.value);
      }
      project = addPrintablesResult.value.updatedProject;
      updateMap(updatedEntitiesMap, addPrintablesResult.value.updatedEntities);
      emptyPrintable = interiorPrintableGroup.printables.find(printable => (0, Printable_1.isPrintableEmpty)(printable));
      if (!emptyPrintable) {
        const step = 'unable to find empty printable';
        sendNewRelicPageAction(Object.assign({
          step,
          error: step
        }, logObject));
        return (0, either_1.left)(new Error(step));
      }
      currentPageCount = (0, getBookInteriorPageCount_1.default)(project.printableGroups, art.category);
    }
    const emptyPrintableIdx = interiorPrintableGroup.printables.indexOf(emptyPrintable);
    let newDesignUserPhotoLayers;
    const numPrintables = (0, Product_1.isSpreadBooksCategory)(art.category) ? currentPageCount / 2 : currentPageCount;
    const pageCountFilter = d => (0, designs_1.isDesignAllowedForPageCount)(d, numPrintables);
    if (!(0, Printable_1.isPartiallyFilledPrintable)(emptyPrintable)) {
      const getDesignResult = (0, helpers_1.getDesignForAutofill)(emptyPrintableIdx, autofillableDesigns, allDesigns, images, new Date(timestamp).getTime(), !!action.restrictToAutofillDesigns, [...(images.length === 1 ? [constants_1.EXCLUDE_PARTIAL_FILTER] : []), ...(action.mobile ? [constants_1.MOBILE_FILTER] : []), ...(art.userCanAddText ? [constants_1.NO_TEXT_FILTER] : []), ...(hasPageCountOption ? [pageCountFilter] : [])]);
      if (getDesignResult.isLeft()) {
        sendNewRelicPageAction(Object.assign({
          step: 'getDesignForAutofill',
          error: getDesignResult.value,
          printableId: emptyPrintable === null || emptyPrintable === void 0 ? void 0 : emptyPrintable.id
        }, logObject));
        return (0, either_1.left)(getDesignResult.value);
      }
      const newDesign = getDesignResult.value;
      const updateDesignResult = (0, updatePrintableDesign_1.default)(project, {
        projectId,
        timestamp,
        type: 'UPDATE_PRINTABLE_DESIGN',
        printableId: emptyPrintable.id,
        designId: newDesign.id,
        printableGroupId: interiorPrintableGroup.id,
        activePage: isSpreadBook ? layers_1.CoverageType.LEFT : undefined
      }, template, art);
      if (updateDesignResult.isLeft()) {
        sendNewRelicPageAction(Object.assign({
          step: 'updatePrintableDesign',
          error: updateDesignResult.value,
          printableId: emptyPrintable === null || emptyPrintable === void 0 ? void 0 : emptyPrintable.id,
          designId: newDesign.id
        }, logObject));
        return (0, either_1.left)(updateDesignResult.value);
      }
      project = updateDesignResult.value.updatedProject;
      updateMap(updatedEntitiesMap, updateDesignResult.value.updatedEntities);
      const getLayersForDesignResult = (0, designs_1.getLayersForDesign)({
        printableGroupType: 'interior',
        template,
        design1: newDesign
      });
      if (getLayersForDesignResult.isLeft()) {
        sendNewRelicPageAction(Object.assign({
          step: 'getLayersForDesignResult',
          error: getLayersForDesignResult.value,
          printableId: emptyPrintable === null || emptyPrintable === void 0 ? void 0 : emptyPrintable.id,
          designId: newDesign.id
        }, logObject));
        return (0, either_1.left)(getLayersForDesignResult.value);
      }
      newDesignUserPhotoLayers = getLayersForDesignResult.value.filter(l => (0, UserPhotoLayer_1.isUserPhotoLayer)(l));
      const isCompositeDesign = newDesign.coverage === 'partial';
      if (isCompositeDesign) {
        const remainingImages = images.slice(newDesignUserPhotoLayers.length);
        const getDesignForRightSideResult = (0, helpers_1.getDesignForAutofill)(emptyPrintableIdx, autofillableDesigns, allDesigns, remainingImages, new Date(timestamp).getTime() * 2, !!action.restrictToAutofillDesigns, [constants_1.PARTIAL_FILTER, ...(action.mobile ? [constants_1.MOBILE_FILTER] : [])]);
        if (getDesignForRightSideResult.isLeft()) {
          sendNewRelicPageAction(Object.assign({
            step: 'getDesignForRightSideResult',
            error: getDesignForRightSideResult.value,
            printableId: emptyPrintable === null || emptyPrintable === void 0 ? void 0 : emptyPrintable.id
          }, logObject));
          return (0, either_1.left)(getDesignForRightSideResult.value);
        }
        const rightSideDesignId = getDesignForRightSideResult.value.id;
        const updateRightSideDesignResult = (0, updatePrintableDesign_1.default)(project, {
          projectId,
          timestamp,
          type: 'UPDATE_PRINTABLE_DESIGN',
          printableId: emptyPrintable.id,
          designId: rightSideDesignId,
          printableGroupId: interiorPrintableGroup.id,
          activePage: isSpreadBook ? layers_1.CoverageType.RIGHT : undefined
        }, template, art);
        if (updateRightSideDesignResult.isLeft()) {
          sendNewRelicPageAction(Object.assign({
            step: 'updateRightSideDesignResult',
            error: updateRightSideDesignResult.value,
            printableId: emptyPrintable === null || emptyPrintable === void 0 ? void 0 : emptyPrintable.id,
            designId: newDesign.id
          }, logObject));
          return (0, either_1.left)(updateRightSideDesignResult.value);
        }
        project = updateRightSideDesignResult.value.updatedProject;
        updateMap(updatedEntitiesMap, updateRightSideDesignResult.value.updatedEntities);
        const compositeDesignId = `${newDesign.id}|${rightSideDesignId}`;
        const getLayersForCompositeDesignResult = (0, designs_1.getLayersForDesign)({
          printableGroupType: 'interior',
          template,
          design1: newDesign,
          design2: getDesignForRightSideResult.value
        });
        if (getLayersForCompositeDesignResult.isLeft()) {
          sendNewRelicPageAction(Object.assign({
            step: 'getLayersForCompositeDesignResult',
            error: getLayersForCompositeDesignResult.value,
            printableId: emptyPrintable === null || emptyPrintable === void 0 ? void 0 : emptyPrintable.id,
            compositeDesignId
          }, logObject));
          return (0, either_1.left)(getLayersForCompositeDesignResult.value);
        }
        newDesignUserPhotoLayers = getLayersForCompositeDesignResult.value.filter(l => (0, UserPhotoLayer_1.isUserPhotoLayer)(l));
      }
    } else {
      newDesignUserPhotoLayers = emptyPrintable.layers.filter(layer => (0, UserPhotoLayer_1.isUserPhotoLayer)(layer) && !layer.userData);
    }
    for (let i = 0; i < newDesignUserPhotoLayers.length; i++) {
      const newDesignLayer = newDesignUserPhotoLayers[i];
      const image = images.shift();
      if (!image) {
        //add warning
        // return left(new Error('No image was found when updating layer.'));
        break;
      }
      const addImageToLayerResult = (0, helpers_1.addImageToLayer)(image, newDesignLayer, emptyPrintable, project, timestamp);
      if (addImageToLayerResult.isLeft()) {
        sendNewRelicPageAction(Object.assign({
          step: 'addImageToLayerResult',
          error: addImageToLayerResult.value,
          printableId: emptyPrintable === null || emptyPrintable === void 0 ? void 0 : emptyPrintable.id,
          image,
          newDesignLayer
        }, logObject));
        return (0, either_1.left)(addImageToLayerResult.value);
      }
      project = addImageToLayerResult.value.updatedProject;
      updateMap(updatedEntitiesMap, addImageToLayerResult.value.updatedEntities);
    }
    emptyPrintable = interiorPrintableGroup.printables.find(printable => (0, Printable_1.hasEmptyUserPhotoLayer)(printable));
  }
  const updatedEntities = Array.from(updatedEntitiesMap.values());
  return (0, either_1.right)({
    updatedProject: project,
    updatedEntities
  });
}
const sendNewRelicPageAction = logObject => {
  if ((0, newrelic_1.canNR)()) {
    window.newrelic.addPageAction('autofill_log', logObject);
  }
};
const updateMap = (updatedEntitiesMap, updatedEntities) => {
  updatedEntities.forEach(entity => {
    updatedEntitiesMap.set(entity.id, entity);
  });
};